import { render } from "./GeneratedQueryDisplay.vue?vue&type=template&id=70091014&scoped=true"
import script from "./GeneratedQueryDisplay.vue?vue&type=script&lang=js"
export * from "./GeneratedQueryDisplay.vue?vue&type=script&lang=js"

import "./GeneratedQueryDisplay.vue?vue&type=style&index=0&id=70091014&scoped=true&lang=css"
import "./GeneratedQueryDisplay.vue?vue&type=style&index=1&id=70091014&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70091014"]])

export default __exports__